import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { GridItemsDeletePayload } from 'Interfaces/Grid';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: GridItemsDeletePayload) =>
    $actions.grid.deleteGridItems(dispatch, payload),
  );
};
